const donutChart = (() => {
    /**
     * init : initializing bar group chart
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param config object
     */
	const init = (config) => {
		const { width, height, data } = config;
		var center = 1;

		var svg = d3.select(config.id)
			.attr("width", width)
			.attr("height", height)
			.append("g");

		svg.append("g")
			.attr("class", "slices");
		svg.append("g")
			.attr("class", "labels");
		svg.append("g")
			.attr("class", "lines");
		const radius = Math.min(width, height) / 2;
		const color = d3.scaleOrdinal(["#158cdc", "#fe9006",]);
		const pie = d3.pie().value(d => d.value);
		const arc = d3.arc().innerRadius(radius * 0.65).outerRadius(radius * 0.6).cornerRadius(2);

		const outerArc = d3.arc()
			.outerRadius(radius * 0.9)
			.innerRadius(radius * 0.9);


		var outterBorder = svg.selectAll("g.outter-arc")
			.data(pie(data))
			.enter()
			.append("g")
			.attr("class", "outter-arc")
			.attr("width", width)
			.attr("transform", "translate(" + center + ", " + center + ")");

		var outerBorderThickness = d3.arc()
			.innerRadius(120)
			.outerRadius(150);




		svg.attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

		svg.selectAll('path')
			.data(pie(data))

			.enter()
			.append('path')

			.attr('d', arc)
			.transition()

			.duration(800)
			.attrTween('d', function (d) {
				var i = d3.interpolate(d.startAngle + 0.0, d.endAngle);
				return function (t) {
					d.endAngle = i(t);
					return arc(d)
				}
			})
			.attr('fill', (d, i) => color(i));
		// svg.append('g').classed('labels',true);
		// svg.append('g').classed('lines',true);



		var polyline = svg.select('.lines')
			.selectAll('polyline')
			.data(pie(data))
			.enter().append('polyline')
			.attr('points', function (d) {

				// see label transform function for explanations of these three lines.
				var pos = outerArc.centroid(d);
				pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
				return [arc.centroid(d), outerArc.centroid(d), pos]
			});



		var label = svg.select('.labels').selectAll('text')
			.data(pie(data))
			.enter().append('text')
			.attr('dy', '.35em')
			.attr('class', "account-text")
			.text(function (d) {
				return initScript.separateNumberByDelimiterWithSignAndThousand(d.data.value);
			})
			.attr('transform', function (d) {
				var pos = outerArc.centroid(d);
				pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
				return 'translate(' + pos + ')';
			})
			.style('text-anchor', function (d) {
				return (midAngle(d)) < Math.PI ? 'start' : 'end';
			});



		svg.append('text')
			.attr('class', 'toolCircle account-text')
			.attr('dy', 0) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
			.text(function(d, i) {
				return data[i].label;
			}) // add text to the circle.
			.style('font-size', '1em')
			.style('text-anchor', 'middle');

		function midAngle(d) { return d.startAngle + (d.endAngle - d.startAngle) / 2; }
		outterBorder.append("path")
			.attr("fill", 'rgba(44, 162, 241, 0.08)')
			.attr("d", outerBorderThickness).style('stroke', 'white')
			.style('stroke-width', 0);
	}
	return {
		init,
	};
})();
